module.exports = __webpack_public_path__ + "Roboto-Thin.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Thin.woff2
// module id = 102
// module chunks = 0